import { render, staticRenderFns } from "./reporteCobranzaI.vue?vue&type=template&id=30f33641"
import script from "./reporteCobranzaI.vue?vue&type=script&lang=js"
export * from "./reporteCobranzaI.vue?vue&type=script&lang=js"
import style0 from "./reporteCobranzaI.vue?vue&type=style&index=0&id=30f33641&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports